<template>
  <div>
    <MealDetail2 v-if="showMealDetail" :mealId="mealId" :date="date" :dense="dense" :read-only="readOnly"
                :allowNameEdit="!readOnly"/>
    <Plating v-if="showPlating" :mealId="mealId" :date="dates[0]" :dates="dates" :production="production"
             :read-only="readOnly"/>
  </div>
</template>

<script>
import MealDetail2 from '@/components/MealDetail2';
import Plating from '@/components/Plating';
import {extractDateFromDateProduction, extractProductionFromDateProduction} from "@/store/utils";

export default {
  name: "Meal2",
  props: {
    readOnly: {type: Boolean, required: true},
    mealId: [Number, String],
    date: String,
    dense: Boolean
  },
  components: {
    MealDetail2,
    Plating
  },
  computed: {
    dates() {
      return [extractDateFromDateProduction(this.date)];
    },
    production() {
      return extractProductionFromDateProduction(this.date);
    },
    showMealDetail() {
      return !(this.$route.query.plating && this.$route.query.plating === '1');
    },
    showPlating() {
      return this.$route.query.plating === '1';
    }
  }
}
</script>

<style scoped>

</style>

